import { h } from '../utils'
import { fieldError } from './error'
import { uniqueId } from './id'
import { fieldLabel } from './label'

interface FileFieldOptions {
  label: string
  name: string
  placeholder?: string
  required?: boolean
  validExtensions?: string[]
  hidden?: boolean
}

export function fileField(options: FileFieldOptions) {
  const id = uniqueId()
  const control = h('div', { class: 'vbzc-control' })

  // Input
  const input = h(
    'input',
    {
      type: 'file',
      accept: options.validExtensions?.join(',') ?? '',
      id,
      name: options.name,
      placeholder: options.placeholder ?? '',
      multiple: '',
    },
    { parent: control },
  )

  // Error
  const { el: error } = fieldError()

  // Field
  const field = h(
    'div',
    { 'class': 'vbzc-field' + (options.hidden ? ' vbzc-field-hidden' : ''), 'data-name': options.name },
    { children: [fieldLabel({ text: options.label, id, required: options.required }), control, error] },
  ) as HTMLDivElement

  return { field, input, error }
}
